import React, { useEffect, useState } from 'react';
import { Button, Form, Input, List, App } from 'antd';

interface LoginData {
  name: string;
  token: string;
}

const Home: React.FC = () => {
  const [form] = Form.useForm();
  const { notification } = App.useApp();
  const [token, setToken] = useState<string>('');
  const [loginHistory, setLoginHistory] = useState<LoginData[]>([]);

  useEffect(() => {
    const localStorageToken = localStorage.getItem('x-nc-code');
    const savedLoginHistory = localStorage.getItem('login-history');

    if (localStorageToken) {
      setToken(localStorageToken);
      form.setFieldsValue({ token: localStorageToken });
    }

    if (savedLoginHistory) {
      setLoginHistory(JSON.parse(savedLoginHistory));
    }
  }, [form]);

  const handleLogin = (values: { name: string; token: string }) => {
    (window as any)['REACT_AUTH_TOKEN'] = values.token;
    localStorage.setItem('x-nc-code', values.token);
    setToken(values.token);

    // Add to login history
    const newLoginHistory = [...loginHistory];
    const existingIndex = newLoginHistory.findIndex((item) => item.token === values.token);

    if (existingIndex >= 0) {
      newLoginHistory.splice(existingIndex, 1);
    }

    newLoginHistory.unshift({
      name: values.name || 'Unknown',
      token: values.token,
    });

    setLoginHistory(newLoginHistory);
    localStorage.setItem('login-history', JSON.stringify(newLoginHistory));

    if (values.token) {
      notification.success({
        message: 'Login Success',
        description: 'You have successfully logged in.',
        duration: 10,
      });
    }
  };

  const handleLogout = () => {
    (window as any)['REACT_AUTH_TOKEN'] = undefined;
    localStorage.removeItem('x-nc-code');
    setToken('');
    form.resetFields();
  };

  const handleLoginData = (data: LoginData) => {
    form.setFieldsValue(data);
    handleLogin(data);
  };

  const clearLoginHistory = () => {
    setLoginHistory([]);
    localStorage.removeItem('login-history');
  };

  const handleRemoveHistoryItem = (itemToRemove: LoginData) => {
    const newHistory = loginHistory.filter((item) => item.token !== itemToRemove.token);
    setLoginHistory(newHistory);
    localStorage.setItem('login-history', JSON.stringify(newHistory));
  };

  return (
    <div style={{ maxWidth: '400px', margin: '40px auto' }}>
      <Form form={form} onFinish={handleLogin} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please input name!' }]}
          tooltip="Type any name to save your login history"
        >
          <Input />
        </Form.Item>

        <Form.Item name="token" label="Token" rules={[{ required: true, message: 'Please input token!' }]}>
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginRight: '8px' }}>
            Login
          </Button>
          <Button onClick={handleLogout} disabled={!token} style={{ marginRight: '8px' }}>
            Logout
          </Button>
          {loginHistory.length > 0 && (
            <Button onClick={clearLoginHistory} danger>
              Clear History
            </Button>
          )}
        </Form.Item>
      </Form>

      {loginHistory.length > 0 && (
        <List
          header={<div>Previous Logins</div>}
          bordered
          dataSource={loginHistory}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button type="link" onClick={() => handleLoginData(item)}>
                  Use
                </Button>,
                <Button type="link" danger onClick={() => handleRemoveHistoryItem(item)}>
                  Remove
                </Button>,
              ]}
            >
              <List.Item.Meta title={item.name} description={`Token: ${item.token.substring(0, 20)}...`} />
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default Home;
